import React from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';
import uniqBy from 'lodash/uniqBy';

import { makeStyles } from '@material-ui/core/styles';

import CriteriumTechnologyBadge from '@hydra/common/criterium/CriteriumTechnologyBadge';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexWrap: 'wrap'
  }
});

export const CriteriumTechnologyList = ({ technologies }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {uniqBy(sortBy(technologies, ['id']), v => v.id)
        .map(technology => (
          <CriteriumTechnologyBadge
            key={technology.id}
            id={technology.id}
            app={technology.app}
          />
        ))}
    </div>
  );
};

CriteriumTechnologyList.propTypes = {
  technologies: PropTypes.array
};

export default CriteriumTechnologyList;
